import React, { PureComponent } from 'react'

import MergeFields from '../../../../utils/MergeFields'

class ReportPageTitle extends PureComponent {
    render() {
        const {
            reportStore,
            h2,
            h3,
            questionTypeCode,
        } = this.props
        return (
            <div className={`surveypage question ${questionTypeCode}`}>
                <h2 className='reportquestiontitle'>
                    {reportStore.stripHtml(MergeFields.replace(h2, reportStore.locale, reportStore.mergeFields))}
                </h2>
                {h3 && (
                    <h3 className='reportquestiontitle'>{reportStore.stripHtml(MergeFields.replace(h3, reportStore.locale, reportStore.mergeFields))}</h3>
                )}
            </div>
        )
    }
}

export default ReportPageTitle
